import { additionalStats } from '@components/Home/AddToStatsModal'
import { DailyStatsType } from '@components/Home/Stats'
import { contentLibrary } from '@components/shared/consts'
import { useUserData } from '@contexts/UserDataContext'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import dayjs from 'dayjs'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const options = {
  plugins: {
    title: {
      display: true,
      text: 'Son 21 Günlük İstatistik',
    },
    legend: {
      display: false,
    },
  },
  responsive: true,
  interaction: {
    mode: 'index' as const,
    intersect: false,
  },

  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
  maintainAspectRatio: false,
}

const getLast21Days = () => {
  const days = []
  for (let i = 21; i >= 0; i--) {
    days.push(dayjs().subtract(i, 'day').format('DD-MM-YYYY'))
  }
  return days
}

const labels = getLast21Days()

type DataSet = {
  label: string
  data: number[]
  backgroundColor: string
  stack: string
}[]

const statsAsDataSets = (stats: DailyStatsType) => {
  const days = labels

  const dataSets: DataSet = []
  contentLibrary.forEach((content) => {
    const dataSet = {
      label: content.name,
      data: [],
      backgroundColor: content.color,
      stack: 'Stack 0',
    }
    days.forEach((day) => {
      // @ts-ignore
      dataSet.data.push(stats?.[day]?.[content.type] || 0)
    })
    dataSets.push(dataSet)
  })

  additionalStats.forEach((stat) => {
    const dataSet = {
      label: stat.name,
      data: [],
      backgroundColor: stat.color,
      stack: 'Stack 0',
    }
    days.forEach((day) => {
      // @ts-ignore
      dataSet.data.push(stats?.[day]?.[stat.type] || 0)
    })
    dataSets.push(dataSet)
  })

  return dataSets
}

const StatsChart = () => {
  const { userData } = useUserData()
  const data = {
    labels,
    datasets: statsAsDataSets(userData.stats),
  }
  return (
    <div className="relative h-96 rounded-2xl p-4 dark:bg-gray-900/60">
      <Bar options={options} data={data} />
    </div>
  )
}

export default StatsChart
